import { DepositForecastItemModel } from "../models/forecast/depositForecastItemModel"

/** Данных выписки планируемого дохода. */
export class ContractForecastData {

  /** Список операций по планируемому доходу. */
  public Operations: DepositForecastItemModel[];

  /** Код валюты. */
  public CurrencyCharCode: string;

  /** Прогноз дохода за месяц. */
  public MonthProfitForecast?: number;

  /** Прогноз дохода на дату закрытия. */
  public ProfitForecast?: number;

  constructor(src?: any) {
    this.Operations = [];
    this.CurrencyCharCode = '';
    this.MonthProfitForecast = undefined;
    this.ProfitForecast = undefined;

    if (src && src.data) {
      const properties = src.data.Data.Properties || {};

      if (properties) {
        this.CurrencyCharCode = properties.currencyCharCode ?? '';
        this.MonthProfitForecast = properties.monthProfitForecast ?? 0;
        this.ProfitForecast = properties.profitForecast ?? null;
      }

      const innerData = src.data.InnerData;
      if (innerData && innerData.Data) {
        for (const key in innerData.Data) {
          if (innerData.Data.hasOwnProperty(key)) {
            const operationSrc = innerData.Data[key].Properties;
            if (operationSrc) {
              this.Operations.push(new DepositForecastItemModel(operationSrc));
            }
          }
        }
      }
    }
  }
}
